import React, { useEffect, useState } from 'react'
import ConsultasFormularios from '../Sql/ConsultasFormularios'
import MsgUtils from '../Tools/MsgUtils';

function EvaluacionesCuestionarios() {
    const [formularios,setFormularios] = useState([]);
    const [loading,setLoading] = useState(false);
    const getFormularios = async () => {
        var infoLogin = JSON.parse(localStorage.getItem('__react_session__'));
        try {
            var result = await ConsultasFormularios.getEvaluaciones({regional: infoLogin.regional,tipo:'A'});
            if(result.ok){
                console.log(result.ok);
                setFormularios(result.ok);
            }else{
                MsgUtils.msgError(result.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        setLoading(true);
        getFormularios()
    }, [])
    return (
        <div>EvaluacionesCuestionarios</div>
    )
}

export default EvaluacionesCuestionarios